import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'System|Criteria|Rules|View Rule|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Core,
	portal: 'SP',
};

type LocNameStart = 'SPSystemCriteriaRulesViewRule';
export type SPSystemCriteriaRulesViewRuleLocNames =
	| `${LocNameStart}LabelSearch`
	| `${LocNameStart}ButtonClear`;

export const spSystemCriteriaRulesViewRuleLocs: LocDefs<SPSystemCriteriaRulesViewRuleLocNames> = {
	SPSystemCriteriaRulesViewRuleLabelSearch: {
		defaultValue: 'Search',
		description: 'Label for: Search.',
		displayPath: `${pathStart}Search`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPSystemCriteriaRulesViewRuleButtonClear: {
		defaultValue: 'Clear',
		description: 'Button for: Clear.',
		displayPath: `${pathStart}Clear`,
		displayType: 'Button',
		...sharedProperties,
	},
};

export type SPSystemCriteriaRulesViewRuleLocType = LocMap<SPSystemCriteriaRulesViewRuleLocNames>;
